/* eslint-disable react-hooks/exhaustive-deps */
import { useNewToast } from 'hooks/newToast';
import { useSafra } from 'hooks/providers/configuracoes/safras';
import React, {
  useState,
  useCallback,
  useContext,
  createContext,
  useMemo,
} from 'react';
import api from 'services';
import { appWarnings } from 'utils/appWarnings';
import { toDate } from 'utils/converters';

const TerreiroContext = createContext({});

export function TerreiroProvider({ children }) {
  const { showToast } = useNewToast();
  const { safraAtual } = useSafra();

  const [terreirosLotes, setTerreirosLotes] = useState([]);
  const [terreirosLotesLoading, setTerreirosLotesLoading] = useState(false);

  const [terreiroLotes, setTerreiroLotes] = useState([]);
  const [terreiroLotesLoading, setTerreiroLotesLoading] = useState(false);

  const [terreiroLotesHistorico, setTerreiroLotesHistorico] = useState({});
  const [terreiroLotesHistoricoLoading, setTerreiroLotesHistoricoLoading] =
    useState(false);

  const getTerreirosLotes = useCallback(async (filter) => {
    try {
      setTerreirosLotesLoading(true);
      const response = await api.terreiro().getTerreirosLotes(filter);
      setTerreirosLotes(response);
      setTerreirosLotesLoading(false);
    } catch (errors) {
      setTerreirosLotesLoading(false);
    }
  }, []);

  const getTerreiroLotes = useCallback(async (id) => {
    try {
      setTerreiroLotesLoading(true);
      const response = await api.terreiro().getTerreiroLotes(id);
      setTerreiroLotes(response);
      setTerreiroLotesLoading(false);
    } catch (errors) {
      setTerreiroLotesLoading(false);
    }
  }, []);

  const [loteNoTerreiro, setLoteNoTerreiro] = React.useState({});
  const [loteNoTerreiroLoading, setLoteNoTerreiroLoading] = React.useState({});

  const getLoteNoTerreiro = useCallback(async (idLote) => {
    try {
      setLoteNoTerreiroLoading(true);
      const response = await api.terreiro().getLoteNoTerreiro(idLote);
      setLoteNoTerreiro(response);
      setLoteNoTerreiroLoading(false);
    } catch (errors) {
      setLoteNoTerreiroLoading(false);
    }
  }, []);

  const getTerreiroHistorico = useCallback(async (id, filter) => {
    try {
      setTerreiroLotesHistoricoLoading(true);
      const response = await api.terreiro().getTerreiroHistorico(id, filter);
      setTerreiroLotesHistorico(response);
      setTerreiroLotesHistoricoLoading(false);
      return response;
    } catch (errors) {
      setTerreiroLotesHistoricoLoading(false);
      return undefined;
    }
  }, []);

  const [gerarNoTerreiroLoading, setGerarNoTerreiroLoading] = useState(false);
  const [lotesUniversais, setLotesUniversais] = useState([]);
  const [lotesUniversaisByTerreiro, setLotesUniversaisByTerreiro] = useState(
    {},
  );
  const [lotesUniversaisLoading, setLotesUniversaisLoading] = useState(false);
  const [loteUniversalDetalhe, setLoteUniversalDetalhe] = useState(null);
  const [loteUniversalDetalheLoading, setLoteUniversalDetalheLoading] =
    useState(false);

  const getLotesUniversais = useCallback(async (terreiroId, filter) => {
    if (terreiroId == null) return [];
    try {
      setLotesUniversaisLoading(true);
      const response = await api
        .terreiro()
        .getLotesUniversais(terreiroId, filter);
      const list = Array.isArray(response) ? response : response?.content ?? [];
      setLotesUniversais(list);
      setLotesUniversaisByTerreiro((prev) => ({
        ...prev,
        [Number(terreiroId)]: list,
      }));
      setLotesUniversaisLoading(false);
      return list;
    } catch (errors) {
      setLotesUniversaisLoading(false);
      setLotesUniversais([]);
      setLotesUniversaisByTerreiro((prev) => ({
        ...prev,
        [Number(terreiroId)]: [],
      }));
      return [];
    }
  }, []);

  const getLoteUniversalDetalhe = useCallback(async (id) => {
    try {
      setLoteUniversalDetalheLoading(true);
      const response = await api.terreiro().getLoteUniversalDetalhe(id);
      setLoteUniversalDetalhe(response);
      setLoteUniversalDetalheLoading(false);
      return response;
    } catch (errors) {
      setLoteUniversalDetalheLoading(false);
      setLoteUniversalDetalhe(null);
      return null;
    }
  }, []);

  const gerarNoTerreiro = useCallback(async (dados) => {
    const {
      data_entrada,
      data_saida,
      hora_entrada,
      hora_saida,
      responsavel,
      terreiro,
      juntar_lote_terreiro_id,
      destinos,
    } = dados.dados;

    let newData;

    if (Array.isArray(destinos) && destinos.length > 0) {
      newData = destinos.map((d) => {
        const payload = {
          lote: (d.lotes || []).map((l) => ({ id: l.id, codigo: l.codigo })),
          data_entrada: toDate(data_entrada),
          data_saida: data_saida ? toDate(data_saida) : '',
          hora_entrada: hora_entrada || '',
          hora_saida: hora_saida || '',
          terreiro: d.terreiro,
          responsavel: d.responsavel ?? '',
        };
        if (
          d.juntar_lote_terreiro_id != null &&
          d.juntar_lote_terreiro_id !== ''
        ) {
          payload.juntar_lote_terreiro_id = Number(d.juntar_lote_terreiro_id);
        }
        return payload;
      });
    } else {
      newData = {
        terreiro: terreiro?.id,
        lote: (dados.escolherLotes || []).map((item) => ({
          id: item.id,
          codigo: item.codigo,
        })),
        data_entrada: toDate(data_entrada),
        data_saida: data_saida && toDate(data_saida),
        hora_entrada,
        hora_saida,
        responsavel,
      };
      const juntarId =
        typeof juntar_lote_terreiro_id === 'object' &&
        juntar_lote_terreiro_id?.id !== undefined
          ? juntar_lote_terreiro_id.id
          : juntar_lote_terreiro_id;
      if (juntarId != null && juntarId !== '') {
        newData.juntar_lote_terreiro_id = Number(juntarId);
      }
    }

    const safraId = dados?.safra ?? safraAtual?.id;
    if (Array.isArray(newData)) {
      if (newData.length > 0) {
        newData[0] = { ...newData[0], safra: safraId };
      }
    } else {
      newData = { ...newData, safra: safraId };
    }

    try {
      setGerarNoTerreiroLoading(true);
      const response = await api.terreiro().gerarNoTerreiro(newData);
      setGerarNoTerreiroLoading(false);
      showToast({
        type: 'success',
        message: 'Entrada no terreiro gerada com sucesso!',
      });
      return response;
    } catch (err) {
      showToast(appWarnings.Danger(err));
      setGerarNoTerreiroLoading(false);
      throw new Error(err);
    }
  }, [showToast, safraAtual]);

  const [editarNoTerreiroLoading, setEditarNoTerreiroLoading] = useState(false);
  const editarNoTerreiro = useCallback(async (id, dados) => {
    const {
      data_entrada,
      data_saida,
      hora_entrada,
      hora_saida,
      responsavel,
      terreiro,
    } = dados.dados;

    const newData = {
      terreiro: terreiro?.id,
      data_entrada: toDate(data_entrada),
      hora_entrada,
      data_saida: data_saida && toDate(data_saida),
      hora_saida,
      responsavel,
    };

    try {
      setEditarNoTerreiroLoading(true);
      const response = await api.terreiro().editarNoTerreiro(id, newData);
      setEditarNoTerreiroLoading(false);
      showToast({
        type: 'success',
        message: 'Entrada no terreiro editada com sucesso!',
      });
      return response;
    } catch (err) {
      showToast(appWarnings.Danger(err));
      setEditarNoTerreiroLoading(false);
      throw new Error(err);
    }
  }, []);

  const [deleteNoTerreiroLoading, setDeleteNoTerreiroLoading] = useState(false);

  const deleteNoTerreiro = useCallback(
    async (id) => {
      try {
        setDeleteNoTerreiroLoading(true);
        await api.terreiro().deleteNoTerreiro(id);
        setDeleteNoTerreiroLoading(false);
        getTerreirosLotes();
        showToast({
          type: 'success',
          message: 'Processo de terreiro removido com sucesso!',
        });
      } catch (err) {
        showToast(appWarnings.Danger(err));
        setDeleteNoTerreiroLoading(false);
        throw new Error(err);
      }
    },
    [getTerreirosLotes, showToast],
  );

  const deleteGrupoNoTerreiro = useCallback(
    async (gloLoteTerreiroId) => {
      try {
        setDeleteNoTerreiroLoading(true);
        await api.terreiro().deleteGrupoNoTerreiro(gloLoteTerreiroId);
        setDeleteNoTerreiroLoading(false);
        getTerreirosLotes();
        showToast({
          type: 'success',
          message: 'Conjunto de lotes removido do terreiro com sucesso!',
        });
      } catch (err) {
        showToast(appWarnings.Danger(err));
        setDeleteNoTerreiroLoading(false);
        throw new Error(err);
      }
    },
    [getTerreirosLotes, showToast],
  );

  const [historicoTalhoes, setHistoricoTalhoes] = React.useState([]);
  const [historicoTalhoesLoading, setHistoricoTalhoesLoading] = React.useState(
    [],
  );

  const listHistoricoTalhoes = useCallback(
    async (filters) => {
      try {
        setHistoricoTalhoesLoading(true);
        const response = await api.terreiro().listHistoricoTerreiros(filters);
        setHistoricoTalhoes(response);
        setHistoricoTalhoesLoading(false);
      } catch {
        setHistoricoTalhoesLoading(false);
      }
    },
    [terreirosLotes],
  );

  const terreirosAgrupados = useMemo(() => {
    const tipos = {};

    terreirosLotes.forEach((terreiro) => {
      const tipo = terreiro.tipo || 'Outros';
      if (!tipos[tipo]) {
        tipos[tipo] = [];
      }
      tipos[tipo].push(terreiro);
    });

    const grupos = Object.keys(tipos).map((tipo) => ({
      label: tipo,
      options: tipos[tipo],
    }));

    return grupos;
  }, [terreirosLotes]);

  const contextValue = useMemo(
    () => ({
      terreirosLotes,
      terreirosAgrupados,
      terreirosLotesLoading,
      getTerreirosLotes,
      terreiroLotes,
      terreiroLotesLoading,
      getTerreiroLotes,
      terreiroLotesHistorico,
      terreiroLotesHistoricoLoading,
      gerarNoTerreiroLoading,
      gerarNoTerreiro,
      getTerreiroHistorico,
      deleteNoTerreiroLoading,
      deleteNoTerreiro,
      deleteGrupoNoTerreiro,
      editarNoTerreiro,
      editarNoTerreiroLoading,
      loteNoTerreiro,
      loteNoTerreiroLoading,
      getLoteNoTerreiro,
      listHistoricoTalhoes,
      historicoTalhoes,
      historicoTalhoesLoading,
      setLoteNoTerreiro,
      lotesUniversais,
      lotesUniversaisByTerreiro,
      lotesUniversaisLoading,
      getLotesUniversais,
      loteUniversalDetalhe,
      loteUniversalDetalheLoading,
      getLoteUniversalDetalhe,
    }),
    [
      terreirosLotes,
      terreirosAgrupados,
      terreirosLotesLoading,
      getTerreirosLotes,
      terreiroLotes,
      terreiroLotesLoading,
      getTerreiroLotes,
      terreiroLotesHistorico,
      terreiroLotesHistoricoLoading,
      gerarNoTerreiroLoading,
      gerarNoTerreiro,
      getTerreiroHistorico,
      deleteNoTerreiroLoading,
      deleteNoTerreiro,
      deleteGrupoNoTerreiro,
      editarNoTerreiro,
      editarNoTerreiroLoading,
      loteNoTerreiro,
      loteNoTerreiroLoading,
      getLoteNoTerreiro,
      listHistoricoTalhoes,
      historicoTalhoes,
      historicoTalhoesLoading,
      setLoteNoTerreiro,
      lotesUniversais,
      lotesUniversaisByTerreiro,
      lotesUniversaisLoading,
      getLotesUniversais,
      loteUniversalDetalhe,
      loteUniversalDetalheLoading,
      getLoteUniversalDetalhe,
    ],
  );

  return (
    <TerreiroContext.Provider value={contextValue}>
      {children}
    </TerreiroContext.Provider>
  );
}

export function useTerreiro() {
  const context = useContext(TerreiroContext);

  if (!context)
    throw new Error('useTerreiro must be used within an AuthProvider');

  return context;
}
